import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoBiggerComponent } from './logo-bigger.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    LogoBiggerComponent
  ],
  exports: [
    LogoBiggerComponent
  ],
  providers: []
})
export class LogoBiggerModule {
}
